import React from "react"
import { ToggleButtonSeeker } from "@ui-seeker/core"
import { useTheme } from "@mui/material"
import { mergeDicts } from "@ui-seeker/utils"


export default function AppToggleButton({ buttonProps={}, ...props }) {
    const {palette} = useTheme()

    return <ToggleButtonSeeker
        buttonProps={{ 
            ...buttonProps,
            sx: mergeDicts({
                px: 4.5,
                fontWeight: 300,
                "&.Mui-selected, &.Mui-selected:hover": {
                    color: "text.primary",
                    fontWeight: 550,
                    backgroundColor: 'primary.light',
                    border: `2px solid ${palette.primary.main} !important`,
                }
            }, buttonProps?.sx)
         }}
        {...props}
    />
}